module.exports = __webpack_public_path__ + "img/logo.c922bb18.png";